import * as Sentry from '@sentry/vue';
import Vue from 'vue';

export const sentryConfigs = {
    vue: function () {
        const sentryDsn = process.env.SENTRY_DSN_FRONTEND
        const sentryEnv = process.env.SENTRY_ENV
        if (sentryDsn && sentryEnv) {
            Sentry.init({
                Vue: Vue,
                dsn: sentryDsn,
                environment: sentryEnv,
                integrations: function (integrations) {
                return integrations.filter(function (integration) {
                    return !['InboundFilters'].includes(integration.name);
                });
            }})
            Sentry.setTag('sentry_config_key', 'vue')
        }
    },
    js: function () {
        const sentryDsn = process.env.SENTRY_DSN_FRONTEND
        const sentryEnv = process.env.SENTRY_ENV
        if (sentryDsn && sentryEnv) {
            Sentry.init({
                dsn: sentryDsn,
                environment: sentryEnv,
                integrations: function (integrations) {
                    return integrations.filter(function (integration) {
                        return !['InboundFilters'].includes(integration.name);
                });
            }}),
            Sentry.setTag('sentry_config_key', 'js')
        }
    }
}